export const CLIENT = "CL";
export const SHAREHOLDER = "SHAR_HOLD";
export const ADMINISTRATOR = "ADM";
export const GUARANTOR = "GUAR";
